import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { TravelBoardService } from '../../services/travel-board.service';
import { environment } from '../../../../environments/environment';
import { TravelBoardData } from 'src/app/shared/model/travel-board-data';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { LucideAngularModule } from 'lucide-angular';
import { TranslocoPipe } from '@jsverse/transloco';
import { GreentripperPinIconComponent } from 'src/app/shared/components/greentripper-pin-icon/greentripper-pin-icon.component';
import { TooltipModule } from 'primeng/tooltip';
import { FormatCO2ePipe } from 'src/app/pipes/format-co2e.pipe';
import { ClientAvatarComponent } from '../client-avatar/client-avatar.component';
import { ButtonModule } from 'primeng/button';
import { EcoscoreComponent } from '../ecoscore/ecoscore.component';
import { ActionsComponent } from 'src/app/shared/actions/actions.component';

@Component({
  selector: 'app-grid-view',
  imports: [
    LucideAngularModule,
    TranslocoPipe,
    GreentripperPinIconComponent,
    TooltipModule,
    FormatCO2ePipe,
    ClientAvatarComponent,
    ButtonModule,
    PaginatorModule,
    EcoscoreComponent,
    ActionsComponent,
  ],
  templateUrl: './grid-view.component.html',
  styleUrl: './grid-view.component.scss',
})
export class GridViewComponent implements OnInit, OnChanges {
  trips: TravelBoardData[] = [];
  allTrips: TravelBoardData[] = [];
  travelBoardService = inject(TravelBoardService);
  page: PaginatorState = {
    page: 0,
    first: 0,
    rows: 12,
  };

  @Input() filteredTrips: TravelBoardData[] = [];
  @Output() pageChange = new EventEmitter<{ page: number; rows: number }>();

  ngOnInit(): void {
    // Initialize pagination from service (which reads from URL query params)
    const initialPage = this.travelBoardService.paginationPage();
    const initialRows = this.travelBoardService.paginationRows();
    // Only use valid grid rows options
    const validRows = [12, 24, 48].includes(initialRows) ? initialRows : 12;
    this.page = {
      page: initialPage,
      first: initialPage * validRows,
      rows: validRows,
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filteredTrips']) {
      this.allTrips = this.filteredTrips;
      // Clamp page if data reduced by filter (don't reset if page is valid)
      const maxPage = Math.max(
        0,
        Math.ceil(this.allTrips.length / (this.page.rows ?? 12)) - 1,
      );
      if ((this.page.page ?? 0) > maxPage) {
        this.page.page = maxPage;
        this.page.first = maxPage * (this.page.rows ?? 12);
      }
      this.updateTrips();
    }
  }

  // Pagination
  onPageChange(page: PaginatorState) {
    this.page = page;
    this.updateTrips();
    // Emit to parent for URL update
    this.pageChange.emit({ page: page.page ?? 0, rows: page.rows ?? 12 });
  }

  updateTrips() {
    if (this.page.first !== undefined && this.page.rows !== undefined) {
      this.trips = this.allTrips.slice(
        this.page.first,
        this.page.first + this.page.rows,
      );
    }
  }

  getImageUrl(path: string | undefined): string {
    if (!path) return '../../../assets/create_account.jpg';
    return path.startsWith('http') ? path : `${environment.apiUrl}${path}`;
  }
}
